import { LocalFile } from '@graphql/generated';

// Copilot review, PR #5914: MyChatForm.tsx and ShareIntentToChat.tsx (shared,
// non-platform-split files) import these from '@utils/videoCompression',
// which resolves to this .web.ts stub on web -- without re-exporting them
// here, they're undefined at runtime on web and break every file upload,
// not just video ones. Both live in a native-free module so re-exporting
// them here doesn't pull react-native-compressor/expo-file-system into the
// web bundle.
export {
  isVideoLike,
  getVideoUnsupportedAlertMessage,
  isVideoByMimeOrName,
  extractFileExtension,
} from '@utils/videoUploadOutcome';

export const compressVideo = async (
  localFile: LocalFile,
  _onProgress?: (progress: number) => void
): Promise<LocalFile> => localFile;

export const compressVideos = async (
  localFiles: LocalFile[],
  _onProgress?: (
    fileIndex: number,
    totalFiles: number,
    progress: number
  ) => void
): Promise<{ files: LocalFile[]; unsupported: LocalFile[] }> => ({
  files: localFiles,
  unsupported: [],
});
